import React from 'react';
import { connect } from 'react-redux';

import { getSelectOptions } from 'src/reducers/selectOptions';
import { redirectTo, concatParamsToUrl } from 'src/utils/Http';
import { CLIENT_CUSTOM_FEATURE_SETTING } from 'src/constants/EndpointUrls';

import { SelectField, InputField } from '../form';

const CustomFeatureEditing = ({
  selectedCustomFeatureType,
  selectedCustomFeatureOption,
  selectedCustomFeatureCondition,
  selectedCustomFeatureStatus,
  params,
  submit,
  submitting,
  isNewForm
}) => {
  const handleCancelClick = () => {
    redirectTo(concatParamsToUrl(CLIENT_CUSTOM_FEATURE_SETTING, { client_id: params.client_id }));
  };

  return (
    <form onSubmit={submit}>
      <div className="form-group mb-3">
        <SelectField name="featureType" require label="Type" options={selectedCustomFeatureType} />
      </div>
      <div className="form-group mb-3">
        <SelectField name="option" required label={'Option'} options={selectedCustomFeatureOption} />
      </div>
      <div className="form-group mb-3">
        <SelectField name="condition" required label={'Condition'} options={selectedCustomFeatureCondition} />
      </div>
      <div className="form-group mb-3">
        <InputField name="value" required label={'Value'} />
      </div>

      {!isNewForm && (
        <div className="form-group mb-3">
          <SelectField name="status" required label={'Status'} options={selectedCustomFeatureStatus} />
        </div>
      )}

      <div className="d-flex align-items-center justify-content-center" style={{ gap: '1rem' }}>
        <button onClick={handleCancelClick} className="btn btn-outline-dark">
          Cancel
        </button>
        <button className="btn btn-primary" onClick={submit} disabled={submitting}>
          Save
        </button>
      </div>
    </form>
  );
};

const mapStateToProps = state => ({
  selectedCustomFeatureType: getSelectOptions(state, 'deskClientCustomFeatureTypes'),
  selectedCustomFeatureOption: getSelectOptions(state, 'deskClientCustomFeatureOptions'),
  selectedCustomFeatureCondition: getSelectOptions(state, 'deskClientCustomFeatureConditions'),
  selectedCustomFeatureStatus: getSelectOptions(state, 'deskClientCustomFeatureStatuses')
});

export default connect(mapStateToProps)(CustomFeatureEditing);
